(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class RllSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-rll-slide]'));
      this.indicators = Array.from(this.querySelectorAll('[data-rll-indicator]'));
      this.currentDisplay = this.querySelector('[data-rll-current]');
      this.autoplayButton = this.querySelector('[data-rll-autoplay]');

      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );

      this.isPaused = false;
      this.delay = Number(this.dataset.delay) || 5000;

      this.querySelector('[data-rll-previous]')?.addEventListener('click', () => {
        this.show(this.index - 1);
        this.restart();
      });

      this.querySelector('[data-rll-next]')?.addEventListener('click', () => {
        this.show(this.index + 1);
        this.restart();
      });

      this.indicators.forEach((indicator) => {
        indicator.addEventListener('click', () => {
          this.show(Number(indicator.dataset.slideIndex));
          this.restart();
        });
      });

      this.autoplayButton?.addEventListener('click', () => {
        this.isPaused = !this.isPaused;

        this.autoplayButton.classList.toggle('is-paused', this.isPaused);

        this.autoplayButton.setAttribute(
          'aria-pressed',
          String(this.isPaused)
        );

        this.autoplayButton.setAttribute(
          'aria-label',
          this.isPaused
            ? this.autoplayButton.dataset.playLabel
            : this.autoplayButton.dataset.pauseLabel
        );

        if (this.isPaused) {
          this.stop();
        } else {
          this.start();
        }
      });

      this.addEventListener('mouseenter', () => this.stop());

      this.addEventListener('mouseleave', () => {
        if (!this.isPaused) this.start();
      });

      this.addEventListener('focusin', () => this.stop());

      this.addEventListener('focusout', () => {
        if (!this.isPaused) this.start();
      });

      if (this.dataset.autoplay === 'true') {
        this.start();
      }

      this.show(this.index);
    }

    disconnectedCallback() {
      this.stop();
    }

    show(requestedIndex) {
      if (this.slides.length === 0) return;

      this.index =
        (requestedIndex + this.slides.length) %
        this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;

        slide.classList.toggle(
          'is-active',
          isActive
        );

        slide.setAttribute(
          'aria-hidden',
          String(!isActive)
        );

        slide.inert = !isActive;
      });

      this.indicators.forEach(
        (indicator, indicatorIndex) => {
          const isActive =
            indicatorIndex === this.index;

          indicator.classList.toggle(
            'is-active',
            isActive
          );

          indicator.setAttribute(
            'aria-current',
            String(isActive)
          );
        }
      );

      if (this.currentDisplay) {
        this.currentDisplay.textContent =
          String(this.index + 1);
      }
    }

    start() {
      if (
        this.dataset.autoplay !== 'true' ||
        this.slides.length < 2 ||
        this.isPaused
      ) {
        return;
      }

      this.stop();

      this.timer =
        window.setInterval(
          () => this.show(this.index + 1),
          this.delay
        );
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = undefined;
      }
    }

    restart() {
      if (!this.isPaused) {
        this.start();
      }
    }
  }

  if (!customElements.get('rll-slideshow')) {
    customElements.define(
      'rll-slideshow',
      RllSlideshow
    );
  }

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const slide =
        event.target.closest(
          '[data-rll-slide]'
        );

      const slideshow =
        event.target.closest(
          'rll-slideshow'
        );

      if (!slide || !slideshow) return;

      slideshow.stop();
      slideshow.isPaused = true;

      slideshow.show(
        Number(
          slide.dataset.slideIndex
        )
      );
    }
  );

  } catch(e) { console.error(e); }
})();
})();
